import React, { useState, useEffect } from 'react'
import { useGameplayContext } from '../../contexts/gameplayContext'
import { MetricCard } from '../shared/MetricCard'
import SKILL_TREE from '../../constants/skillTree'
import SKILLS from '../../constants/skills'
import { getOverallSkillLevel } from '../../utils'
import { Tabs } from '../shared/Tabs'
import { IndividualSkillCard } from '../shared/IndividualSkillCard'
import { SkillPill } from '../shared/SkillPill'
import { OverallSkillCard } from '../shared/OverallSkillCard'
import { SurfLevelCard } from '../shared/SurfLevelCard'

export const SkillsScreen: React.FC = () => {
  const [expandedLevel, setExpandedLevel] = useState<number | null>(null)
  const { gameData, setGameData } = useGameplayContext()

  const handleTabChange = (value: string) => {
    setGameData((prev) => ({
      ...prev,
      tabs: {
        ...prev.tabs,
        skills: value
      }
    }))
  }

  const tabs = [
    { value: 'skills', label: '🏆 Skills' },
    { value: 'overall', label: '🏄‍♂️ Surf Level' }
  ]

  useEffect(() => {
    const firstNotFullyUnlockedIndex = SKILL_TREE.findIndex(
      (skillLevel) => !getOverallSkillLevel([skillLevel], gameData.skills)
    )
    setExpandedLevel(firstNotFullyUnlockedIndex !== -1 ? firstNotFullyUnlockedIndex : null)
  }, [gameData.skills])

  const getVisibleSkillLevels = () => {
    const firstNotAchievedIndex = SKILL_TREE.findIndex(
      (skillLevel) => !getOverallSkillLevel([skillLevel], gameData.skills)
    )
    if (firstNotAchievedIndex === -1) {
      return SKILL_TREE
    }
    return SKILL_TREE.slice(0, firstNotAchievedIndex + 1)
  }

  return (
    <div className="space-y-6">
      <h2 className="text-3xl font-bold text-white drop-shadow-md">Skills 🏆</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <SurfLevelCard />
        <MetricCard emoji="🏆" label="Total Skill Points" value={gameData.currencies.skill.amount} />
      </div>

      <Tabs tabs={tabs} activeTab={gameData.tabs.skills} onChange={handleTabChange} />

      {gameData.tabs.skills === 'overall' && (
        <div className="space-y-4">
          {getVisibleSkillLevels().map((skillLevel, index) => (
            <OverallSkillCard
              key={index}
              skillLevel={skillLevel}
              gameSkills={gameData.skills}
              isExpanded={index === expandedLevel}
              onToggle={() => setExpandedLevel(index === expandedLevel ? null : index)}
            />
          ))}
        </div>
      )}

      {gameData.tabs.skills === 'skills' && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {Object.values(SKILLS)
            .sort((a, b) => a.order - b.order)
            .map((skill) => (
              <IndividualSkillCard
                key={skill.key}
                skillKey={skill.key}
                reachedLevel={gameData.skills[skill.key].level}
                requiredLevel={gameData.skills[skill.key].level + 1}
                gameSkill={gameData.skills[skill.key]}
                showDetails={true}
              />
            ))}
        </div>
      )}
    </div>
  )
}
